export enum ShoppingCartStepType {
  ShoppingCart = '/shopping-cart',
}
